import React from "react";
import values from "../../values";
import Context from "../../context";
import Components from "./Components";

import {
  BreadCrumb,
  Pagination,
  TableHeader,
  TableLoading,
  ResponsiveView,
} from "../../components";

import "./index.sass";
import utils from "../../utils";
import Cookies from "js-cookie";
import constants from "../../values/constants";
import { COMPANY_HEADERS_FOR_MUNICIPALITY } from "../../values/tableHeaders";
import { useTranslation } from "react-i18next";
import RadioButton from "../../components/RadioButton";

type Props = {
  rqCompany: any;
  role: "ADMIN" | "SUPER_AGENT_SCHOOL";
};

const CompanyScreen = (props: Props) => {
  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );
  const { data, status } = props.rqCompany;
  const { requestCompany, setRequestCompany } = React.useContext(
    Context.CompanyScreen
  );

  const [isFavorite, setIsFavorite] = React.useState<boolean>(false);

  const writePermission = Cookies.get(
    constants.USER.WRITE_PERMISSION
  )?.toString();

  const tableHeader: Array<string> =
    userType === "ADMIN"
      ? values.tableHeaders.COMPANY_HEADERS_FOR_ADMIN
      : userType === "MUNICIPALITY"
      ? COMPANY_HEADERS_FOR_MUNICIPALITY
      : values.tableHeaders.COMPANY_HEADERS;

  function toggleFavorite(event: boolean): void {
    setIsFavorite(event)
    if (event) {
      setRequestCompany({
        ...requestCompany,
        filters: {
          ...requestCompany.finters,
          isFavorite: true,
        }
      })
    } else {
      setRequestCompany({
        ...requestCompany,
        filters: {
          ...requestCompany.finters,
          isFavorite: undefined,
        }
      })
    }
  }

  const { t } = useTranslation();

  return (
    <ResponsiveView.Container id="company-screen-container">
      <ResponsiveView.Row className="table-options-wrapper">
        <ResponsiveView.Column
          extraLarge={4}
          large={6}
          medium={6}
          className="bread-crumb-wrapper"
        >
          <div className='header-siction'>
            <BreadCrumb />
            <div className='is-favorite'>
              <RadioButton value={isFavorite} onToggle={toggleFavorite} />
              <p>فیلتر علاقه‌مندی</p>
            </div>
          </div>

        </ResponsiveView.Column>
        <ResponsiveView.Column
          extraLarge={4}
          large={5}
          medium={7}
          className="search-and-filter-wrapper"
        >
          {writePermission === "true" && (
            <Components.Create role={props.role} />
          )}
          <Components.Filter />
          <Components.Search />
        </ResponsiveView.Column>
      </ResponsiveView.Row>
      <div className="table-content-wrapper">
        <table>
          <TableHeader headers={tableHeader.map((item) => t(item))} />
          {status === "loading" ? (
            <TableLoading />
          ) : (
            <Components.Body data={data?.result?.docs} />
          )}
        </table>
      </div>
      {status === "success" &&
        data?.result?.totalDocs >
          values.constants.PANEL_TABLE_DEFAULT_LIMIT && (
          <div className="pagination">
            <Pagination
              page={requestCompany?.page}
              totalPages={data?.result?.totalPages}
              onPaginate={(page: number) =>
                setRequestCompany({ ...requestCompany, page })
              }
            />
          </div>
        )}

      {writePermission === "true" && <Components.Update role={props.role} />}
      <Components.SuperAgentInformation />
      <Components.CompanyInformation    />
      <Components.ManagerInformation    />
      <Components.ApproveDocuments      />
      <Components.ShowDrivers           />
      <Components.PayDeposit            />
      <Components.Favorite              />
      <Components.Approve               />
    </ResponsiveView.Container>
  );
};

export default CompanyScreen;
